import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoFull16 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 79,
	height: 16,
	viewBox: "0 0 79 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0.653368 14.3173C0.71909 14.3236 0.918222 14.1878 0.99298 14.1466C1.9084 13.6197 3.11744 12.895 4.1997 12.1882L0.716717 10.9104C0.538451 10.8465 0.367019 10.7939 0.370663 10.8604C0.424117 11.8375 0.498118 14.3173 0.653368 14.3173Z",
			fill: "url(#paint0_linear_3444_65699)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.07061 10.3124C6.9895 10.432 1.75028 13.7679 0.99298 14.1466C0.918222 14.1913 0.679586 14.3351 0.651455 14.3154C0.651455 14.3154 1.72425 14.9669 2.1791 15.2535C3.18507 15.8872 3.76567 16.2786 4.56269 15.7596L6.98606 14.1817C7.56495 13.8047 7.75659 12.595 7.67773 11.7617C7.59525 10.8903 7.09164 10.2814 7.07061 10.3124Z",
			fill: "url(#paint1_linear_3444_65699)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.67498 5.64942C3.65792 5.65946 3.6584 5.67618 3.64138 5.68617C2.62587 6.30721 1.32875 6.7325 0.738297 7.95318C1.17834 8.23579 1.32808 8.28852 1.49236 8.35352C3.71506 9.23307 7.00299 10.2148 7.08265 10.3253C8.40187 9.41576 9.47315 8.58286 9.92305 8.08222C9.92451 8.08369 9.92606 8.08523 9.92757 8.08677C9.4254 7.48704 8.65715 7.39008 7.35755 6.91734C6.11776 6.52882 4.84258 6.07258 3.67498 5.64942Z",
			fill: "url(#paint2_linear_3444_65699)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.1231 1.60922C10.1524 1.39309 8.35929 2.53571 6.56927 3.78126C7.56926 4.08266 9.41104 4.75881 9.97084 4.8868C10.0678 4.90897 10.1551 4.92728 10.1476 4.8972C10.1459 3.79213 10.1231 1.60922 10.1231 1.60922Z",
			fill: "url(#paint3_linear_3444_65699)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.40175 2.22241C2.59955 2.75955 1.09324 3.53708 0.486357 4.41198C-0.280982 5.51822 -0.0996687 7.40066 0.744904 7.95712C0.736906 7.75173 3.42143 5.81853 3.69769 5.65575C3.43946 5.48997 2.3599 4.61746 3.40175 2.22241Z",
			fill: "url(#paint4_linear_3444_65699)",
			fillOpacity: .992157
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.39361 2.22862C3.39361 2.22862 5.21929 0.92632 6.36498 0.274827C6.79173 0.0321632 7.05473 0.00431257 7.1848 0.00019049C7.60957 -0.0132703 8.57672 0.689812 9.31312 1.10966C9.76052 1.36473 10.1154 1.57027 10.1152 1.58701C9.82543 1.56676 3.78253 5.69082 3.69595 5.65674C1.95821 4.9893 3.39361 2.22862 3.39361 2.22862Z",
			fill: "url(#paint5_linear_3444_65699)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.92758 8.08683L9.92306 8.08228C9.47316 8.58292 8.38738 9.40626 7.06815 10.3158C7.54835 10.8998 7.72895 11.6648 7.68611 12.3514C7.59652 13.7872 7.06794 14.1006 7.0619 14.1259C8.92221 12.8813 10.0229 12.2828 10.4135 11.4105C10.8739 10.3824 10.7031 8.87423 9.92758 8.08683Z",
			fill: "url(#paint6_linear_3444_65699)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.9897 5.79318C21.6886 5.54877 21.3875 5.37015 21.0864 5.25734C20.7853 5.13513 20.4936 5.07403 20.2113 5.07403C19.8538 5.07403 19.5621 5.15864 19.3363 5.32785C19.1104 5.49706 18.9975 5.71798 18.9975 5.9906C18.9975 6.17861 19.054 6.33373 19.1669 6.45593C19.2798 6.57814 19.4256 6.68625 19.6044 6.78026C19.7926 6.86486 19.9996 6.94007 20.2254 7.00588C20.4607 7.07168 20.6912 7.14219 20.917 7.21739C21.8203 7.51821 22.4789 7.92244 22.8929 8.43008C23.3163 8.92832 23.5281 9.58167 23.5281 10.3901C23.5281 10.9354 23.434 11.4289 23.2458 11.8707C23.067 12.3126 22.7988 12.6933 22.4413 13.0129C22.0932 13.3231 21.6603 13.5629 21.1428 13.7321C20.6347 13.9107 20.0561 14 19.4068 14C18.0613 14 16.8146 13.6005 15.6667 12.8014L16.8522 10.5734C17.2662 10.9401 17.6755 11.2127 18.0801 11.3913C18.4847 11.5699 18.8846 11.6592 19.2798 11.6592C19.7314 11.6592 20.0655 11.5558 20.2819 11.349C20.5077 11.1422 20.6206 10.9072 20.6206 10.6439C20.6206 10.4841 20.5924 10.3478 20.5359 10.235C20.4795 10.1128 20.3854 10.0047 20.2537 9.91069C20.1219 9.80729 19.9479 9.71328 19.7314 9.62867C19.5244 9.54407 19.2704 9.45006 18.9693 9.34665C18.6117 9.23384 18.2589 9.11163 17.9108 8.98002C17.572 8.83901 17.2662 8.6557 16.9934 8.43008C16.7299 8.20446 16.5135 7.92244 16.3441 7.58402C16.1842 7.23619 16.1042 6.79906 16.1042 6.27262C16.1042 5.74618 16.1889 5.27145 16.3582 4.84841C16.537 4.41598 16.7817 4.04935 17.0922 3.74853C17.4121 3.43831 17.7979 3.19859 18.2495 3.02938C18.7105 2.86016 19.2233 2.77556 19.7879 2.77556C20.3148 2.77556 20.8653 2.85076 21.4392 3.00117C22.0132 3.14219 22.5636 3.3537 23.0905 3.63572L21.9897 5.79318Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.1401 8.81081C29.6979 8.50999 29.251 8.35958 28.7993 8.35958C28.5547 8.35958 28.3242 8.40188 28.1078 8.48649C27.9008 8.57109 27.7173 8.6933 27.5573 8.85311C27.3974 9.00353 27.2703 9.18684 27.1762 9.40305C27.0916 9.60987 27.0492 9.84489 27.0492 10.1081C27.0492 10.3619 27.0916 10.5969 27.1762 10.8132C27.2703 11.02 27.3927 11.2033 27.5432 11.3631C27.7032 11.5135 27.8913 11.631 28.1078 11.7156C28.3242 11.8002 28.5547 11.8425 28.7993 11.8425C29.2792 11.8425 29.7261 11.678 30.1401 11.349V13.5206C29.5097 13.7932 28.9122 13.9295 28.3477 13.9295C27.8208 13.9295 27.3174 13.8402 26.8375 13.6616C26.3671 13.483 25.9483 13.2291 25.5814 12.9001C25.2238 12.5617 24.9369 12.1622 24.7204 11.7015C24.504 11.2315 24.3958 10.7098 24.3958 10.1363C24.3958 9.56287 24.4993 9.04113 24.7063 8.57109C24.9133 8.09166 25.1956 7.68273 25.5532 7.3443C25.9107 6.99647 26.3341 6.72855 26.8234 6.54054C27.3221 6.34313 27.8537 6.24442 28.4183 6.24442C29.0393 6.24442 29.6132 6.37603 30.1401 6.63925V8.81081Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.2443 6.47004H33.7989V7.65452C34.0718 7.22209 34.4058 6.89307 34.801 6.66745C35.1962 6.43243 35.6572 6.31492 36.1842 6.31492C36.25 6.31492 36.3206 6.31492 36.3959 6.31492C36.4805 6.31492 36.5746 6.32432 36.6781 6.34313V8.78261C36.3394 8.6134 35.9725 8.52879 35.5773 8.52879C34.9845 8.52879 34.5375 8.7074 34.2365 9.06463C33.9448 9.41246 33.7989 9.92479 33.7989 10.6016V13.7039H31.2443V6.47004Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.0206 6.47004V13.7039H37.466V6.47004H40.0206ZM37.2966 3.69213C37.2966 3.49471 37.3342 3.3114 37.4095 3.14219C37.4848 2.96357 37.5883 2.80846 37.72 2.67685C37.8518 2.54524 38.0023 2.44183 38.1717 2.36663C38.3504 2.29142 38.5386 2.25382 38.7362 2.25382C38.9338 2.25382 39.1173 2.29142 39.2867 2.36663C39.4654 2.44183 39.6207 2.54524 39.7524 2.67685C39.8841 2.80846 39.9876 2.96357 40.0629 3.14219C40.1382 3.3114 40.1758 3.49471 40.1758 3.69213C40.1758 3.88954 40.1382 4.07756 40.0629 4.25617C39.9876 4.42538 39.8841 4.57579 39.7524 4.7074C39.6207 4.83901 39.4654 4.94242 39.2867 5.01763C39.1173 5.09283 38.9338 5.13043 38.7362 5.13043C38.5386 5.13043 38.3504 5.09283 38.1717 5.01763C38.0023 4.94242 37.8518 4.83901 37.72 4.7074C37.5883 4.57579 37.4848 4.42538 37.4095 4.25617C37.3342 4.07756 37.2966 3.88954 37.2966 3.69213Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.186 10.1081C47.186 9.88249 47.1436 9.67098 47.0589 9.47356C46.9743 9.26675 46.8566 9.08813 46.7061 8.93772C46.5556 8.78731 46.3815 8.6698 46.1839 8.58519C45.9863 8.49119 45.7699 8.44418 45.5347 8.44418C45.3088 8.44418 45.0971 8.48649 44.8995 8.57109C44.7019 8.6557 44.5279 8.77321 44.3773 8.92362C44.2362 9.07403 44.1186 9.25264 44.0245 9.45946C43.9398 9.65687 43.8975 9.86839 43.8975 10.094C43.8975 10.3196 43.9398 10.5311 44.0245 10.7286C44.1092 10.926 44.2268 11.0999 44.3773 11.2503C44.5279 11.3913 44.7019 11.5088 44.8995 11.6028C45.1065 11.6874 45.3229 11.7297 45.5488 11.7297C45.7746 11.7297 45.9863 11.6874 46.1839 11.6028C46.3815 11.5182 46.5508 11.4007 46.692 11.2503C46.8425 11.0999 46.9601 10.926 47.0448 10.7286C47.1389 10.5311 47.186 10.3243 47.186 10.1081ZM43.968 2V7.18919C44.5702 6.55934 45.3229 6.24442 46.2262 6.24442C46.7626 6.24442 47.2518 6.34783 47.6941 6.55464C48.1457 6.75206 48.5268 7.02468 48.8373 7.3725C49.1572 7.71093 49.4065 8.11516 49.5853 8.58519C49.7641 9.04583 49.8535 9.53937 49.8535 10.0658C49.8535 10.6016 49.7594 11.1046 49.5712 11.5746C49.3924 12.0447 49.1384 12.4536 48.8091 12.8014C48.4797 13.1492 48.0892 13.4266 47.6376 13.6334C47.1954 13.8308 46.7155 13.9295 46.198 13.9295C45.2571 13.9295 44.5138 13.5864 43.968 12.9001V13.7039H41.4134V2H43.968Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M56.7293 10.1081C56.7293 9.88249 56.687 9.67098 56.6023 9.47356C56.5176 9.26675 56.4 9.08813 56.2494 8.93772C56.0989 8.78731 55.9248 8.6698 55.7272 8.58519C55.5296 8.49119 55.3132 8.44418 55.078 8.44418C54.8522 8.44418 54.6405 8.48649 54.4429 8.57109C54.2453 8.6557 54.0712 8.77321 53.9207 8.92362C53.7795 9.07403 53.6619 9.25264 53.5678 9.45946C53.4831 9.65687 53.4408 9.86839 53.4408 10.094C53.4408 10.3196 53.4831 10.5311 53.5678 10.7286C53.6525 10.926 53.7701 11.0999 53.9207 11.2503C54.0712 11.3913 54.2453 11.5088 54.4429 11.6028C54.6499 11.6874 54.8663 11.7297 55.0921 11.7297C55.3179 11.7297 55.5296 11.6874 55.7272 11.6028C55.9248 11.5182 56.0942 11.4007 56.2353 11.2503C56.3859 11.0999 56.5035 10.926 56.5882 10.7286C56.6823 10.5311 56.7293 10.3243 56.7293 10.1081ZM53.5114 2V7.18919C54.1136 6.55934 54.8663 6.24442 55.7696 6.24442C56.3059 6.24442 56.7952 6.34783 57.2374 6.55464C57.6891 6.75206 58.0701 7.02468 58.3806 7.3725C58.7005 7.71093 58.9499 8.11516 59.1287 8.58519C59.3074 9.04583 59.3968 9.53937 59.3968 10.0658C59.3968 10.6016 59.3027 11.1046 59.1145 11.5746C58.9358 12.0447 58.6817 12.4536 58.3524 12.8014C58.0231 13.1492 57.6326 13.4266 57.181 13.6334C56.7387 13.8308 56.2589 13.9295 55.7414 13.9295C54.8004 13.9295 54.0571 13.5864 53.5114 12.9001V13.7039H50.9568V2H53.5114Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.0547 2V13.7039H60.5001V2H63.0547Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M69.7402 9.03643C69.6556 8.6792 69.4815 8.39248 69.218 8.17626C68.9546 7.96005 68.6347 7.85194 68.2583 7.85194C67.8631 7.85194 67.5385 7.95535 67.2845 8.16216C67.0398 8.36898 66.8846 8.6604 66.8187 9.03643H69.7402ZM66.7481 10.517C66.7481 11.6169 67.2656 12.1669 68.3006 12.1669C68.8558 12.1669 69.2745 11.9412 69.5568 11.49H72.0267C71.528 13.1445 70.2813 13.9718 68.2865 13.9718C67.6749 13.9718 67.1151 13.8825 66.607 13.7039C66.0989 13.5159 65.6614 13.2526 65.2944 12.9142C64.9369 12.5758 64.6593 12.1716 64.4617 11.7015C64.2641 11.2315 64.1653 10.7051 64.1653 10.1222C64.1653 9.52056 64.2594 8.98002 64.4476 8.50059C64.6358 8.01175 64.9039 7.59812 65.2521 7.25969C65.6002 6.92127 66.0189 6.66275 66.5082 6.48414C67.0069 6.29612 67.5667 6.20212 68.1877 6.20212C68.7993 6.20212 69.3498 6.29612 69.8391 6.48414C70.3283 6.66275 70.7423 6.92597 71.0811 7.2738C71.4198 7.62162 71.6785 8.04935 71.8573 8.55699C72.0361 9.05523 72.1255 9.61927 72.1255 10.2491V10.517H66.7481Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.2329 6.47004H75.7875V7.65452C76.0603 7.22209 76.3943 6.89307 76.7895 6.66745C77.1847 6.43243 77.6458 6.31492 78.1727 6.31492C78.2386 6.31492 78.3091 6.31492 78.3844 6.31492C78.4691 6.31492 78.5632 6.32432 78.6667 6.34313V8.78261C78.3279 8.6134 77.961 8.52879 77.5658 8.52879C76.973 8.52879 76.5261 8.7074 76.225 9.06463C75.9333 9.41246 75.7875 9.92479 75.7875 10.6016V13.7039H73.2329V6.47004Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_3444_65699",
				x1: .57211,
				y1: 11.114,
				x2: 2.37778,
				y2: 13.6385,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#00993C",
					stopOpacity: .992157
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .778481,
					stopColor: "#004C2C"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_3444_65699",
				x1: 1.44151,
				y1: 16.3538,
				x2: 7.16087,
				y2: 10.453,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .336437,
					stopColor: "#007541",
					stopOpacity: .988235
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#00BCA1",
					stopOpacity: .992157
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_3444_65699",
				x1: .876471,
				y1: 7.36745,
				x2: 9.73628,
				y2: 8.27654,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .131279,
						stopColor: "#005562"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .49789,
						stopColor: "#007678",
						stopOpacity: .992157
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#0098A6",
						stopOpacity: .992157
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_3444_65699",
				x1: 7.94367,
				y1: 1.8335,
				x2: 10.1159,
				y2: 4.88443,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .359112,
					stopColor: "#003763",
					stopOpacity: .992157
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#00649C",
					stopOpacity: .984314
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_3444_65699",
				x1: .823708,
				y1: 7.52922,
				x2: 3.10283,
				y2: 2.40575,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						stopColor: "#006194",
						stopOpacity: .992157
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .532245,
						stopColor: "#00A1FD",
						stopOpacity: .996078
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#008AD6"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_3444_65699",
				x1: 2.9671,
				y1: 5.15418,
				x2: 9.07335,
				y2: .0701115,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .14968,
						stopColor: "#006AA8"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .377637,
						stopColor: "#0072BD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .818565,
						stopColor: "#00589D"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_3444_65699",
				x1: 7.26351,
				y1: 11.7076,
				x2: 10.7891,
				y2: 9.25762,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .259494,
						stopColor: "#00BE9F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .527272,
						stopColor: "#00B298"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .862869,
						stopColor: "#00A5A8"
					})
				]
			})
		] })
	]
});
export default SvgLogoFull16;
